import styled from 'styled-components'

export const SliderContainer = styled.div`
  padding-top: 16px;
`
